import { dataProps } from './properties'

export const resetGarmentCustomiser = state => {
    state.props = JSON.parse(JSON.stringify(dataProps))
}


// WEBPACK FOOTER //
// ./src/store/modules/garmentCustomiser/mutations.js